import { createTheme } from '@mantine/core';

const theme = createTheme({
	primaryColor: 'dark'
});

export default theme;
